module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg10": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Email Address",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.globalModalParams.customerEmail),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "customerEmail", $$v)
      },
      expression: "globalModalParams.customerEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "bgLightBlue"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSendQuote.apply(null, arguments)
      }
    }
  }, [_vm._v("Send")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg1": ""
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "14px"
    }
  }, [_c('strong', [_vm._v("OR")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg2": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "bgLightBlue"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncDownloadQuote.apply(null, arguments)
      }
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-2 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}